import React, { Component } from 'react'
import './table.scss';
import AmazonLink from './../amazon-link/amazon-link';
import PropTypes from "prop-types";
import { titleToId } from "../../utils";
import isTouchDevice from 'is-touch-device'
import Stars from "../stars/stars";
import classnames from 'classnames'

class Table extends Component {

  render() {
    const { products, tableTitle } = this.props;
    const tableHeaderData = products && products[0].table_features ? products[0].table_features : [];
    const firstCellClassName = classnames('table__cell-first', {
      'table__cell-first--mobile': isTouchDevice()
    });

    return (
      <div className="table__container">
        {tableTitle ? <h2 className="table__title" id={titleToId(tableTitle)}>{tableTitle || null}</h2> : null}
        <div className="table__wrapper">
          <table className="table">
            <thead className="table__head">
              <tr className="table__row">
                <th className="table__header">Name</th>
                {
                  products && products[0].rating ?
                    <th className="table__header">Our rating</th>
                    : null
                }
                {
                  tableHeaderData.map((title, index) => {
                    return <th className="table__header" key={index}>{title.feature_name}</th>
                  })
                }
                <th className="table__header">Shops</th>
              </tr>
            </thead>
            <tbody className="table__body">
              {
                products.map((product, i) => {
                  return (
                    <tr className="table__row" key={product.product_name}>
                      <td className={`${firstCellClassName}`}>
                        <span className={product.featured}></span>
                        <a
                          target="_blank"
                          className="table__product-name"
                          href={product.amazon_link}
                          data-vars-product-name={product.product_name}
                        >
                          {product.product_name}
                        </a>
                      </td>
                      {
                        product.rating ?
                          <td className="table__cell">
                            <Stars rating={product.rating} />
                          </td> : null
                      }
                      {
                        product.table_features ?
                          this.generateTableCells(product.table_features)
                          : null
                      }
                      {
                        this.getCheckPriceCol(product)
                      }
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
        <p className={`table__mobile-info ${isTouchDevice() ? 'visible' : null}`}>swipe left to see more</p>
      </div>
    )
  }

  getCheckPriceCol = (product) => (
    <td className="table__cell">
      <AmazonLink
        isInsideTable
        link={product.amazon_link}
        title="Check price"
        className="ga-amazon-link-from-table"
        productName={product.product_name}
      />
    </td>
  );

  generateTableCells = (tableFeatures) => (
    tableFeatures.map((cell, index) => {
      return <td className="table__cell" key={index}>{cell.feature_value}</td>;
    })
  )
}

Table.propTypes = {
  products: PropTypes.array,
  tableTitle: PropTypes.string,
};

export default Table;


// WEBPACK FOOTER //
// ./src/components/table/table.js